import { ChatSidebar } from "@/libs/chat/components/ChatSidebar";

export function ChatsPage() {
  return (
    <div className="h-screen bg-white flex flex-col">
      <ChatSidebar />
    </div>
  );
}
